export enum ActivityType {
  FoiCreateNote = 3000,
  FoiInternalMessage = 3001,
  FoiAssigned = 3002,
  FoiUnassigned = 3003,
  FoiClosed = 3004,
  FoiReopened = 3005,
  FoiCancelled = 3006,
  FoiCreatedFromPublicEnquiry = 3007,
  FoiEventAdded = 3008,
  FoiEventCompleted = 3009,
  PublicEnquiryPublicMessage = 2010,
  FoiPublicMessageFromOfqual = 2012,
  ShareRecord = 17,
  UnSharedRecord = 86,
  PublicEnquiryCreatedFromFoi = 2006,
}
